import { useThemeToggler } from '@seller-hermes/hooks/useThemeToggler';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import { IconButton } from './theme-selector.styles';

type ThemePreference = 'light' | 'dark' | 'system';

// Cicla entre as 3 opções: Claro → Escuro → Sistema → Claro.
const NEXT_PREFERENCE: Record<ThemePreference, ThemePreference> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

const ThemeSelector = () => {
  const { themePreference, setTheme } = useThemeToggler();

  const cycle = () => {
    setTheme(NEXT_PREFERENCE[themePreference]);
  };

  const icon =
    themePreference === 'system' ? (
      <DesktopWindowsIcon />
    ) : themePreference === 'dark' ? (
      <Brightness4Icon />
    ) : (
      <Brightness7Icon />
    );

  return (
    <IconButton onClick={cycle} title={themePreference}>
      {icon}
    </IconButton>
  );
};

export default ThemeSelector;
